import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import { Disclaimer } from 'src/components/sidebar/disclaimer';
import AboutContent from 'src/modules/programs/components/aboutContent';
import ModuleContent from 'src/modules/programs/components/moduleContent';
export default function MainContent() {
  const {
    currentModule = null
  } = useSelector(({
    pages
  }) => pages.programs);
  return <Wrapper data-sentry-element="Wrapper" data-sentry-component="MainContent" data-sentry-source-file="mainContent.tsx">
      {!currentModule ? <AboutContent /> : <ModuleContent />}
      <MobileDisclaimer data-sentry-element="MobileDisclaimer" data-sentry-source-file="mainContent.tsx">
        <Disclaimer data-sentry-element="Disclaimer" data-sentry-source-file="mainContent.tsx" />
      </MobileDisclaimer>
    </Wrapper>;
}
const Wrapper = styled.div`
  flex: 2;
  margin-left: 7%;

  @media (${props => props.theme.underScreenMedium}) {
    width: 100%;
    margin-top: 30px;
    margin-left: 0;
    padding: 0 20px;
  }

  @media (${props => props.theme.underScreenXxsmall}) {
    padding: 0 15px;
  }
`;
const MobileDisclaimer = styled.div`
  margin-top: 20px;

  @media (${props => props.theme.overScreenMedium}) {
    display: none;
  }
`;